import axios from 'axios';

const API_URL = '/api/counters';

/**
 * Service pour gérer les opérations liées aux guichets
 */
const counterService = {
  /**
   * Récupérer tous les guichets
   * @returns {Promise} Promesse résolue avec la liste des guichets
   */
  getAllCounters: async () => {
    try {
      const response = await axios.get(API_URL);
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des guichets:', error);
      throw error;
    }
  },

  /**
   * Récupérer le statut d'un guichet spécifique
   * @param {number} counterId - ID du guichet
   * @returns {Promise} Promesse résolue avec les données du guichet
   */
  /**
   * Performance du JOUR par guichet, recalculée par le serveur depuis les tickets terminés.
   *
   * `GET /api/stats` renvoie `{ stats, counters }`, où `counters[id]` vaut
   * `{ servedClients, averageServiceTime, totalServiceTime }` — secondes pour les durées.
   *
   * C'est la SEULE source valable : le champ `dailyStats` de l'enregistrement du guichet
   * n'est jamais incrémenté (dans @mostajs/queue, seul `resetDaily` l'écrit, et il y met
   * des zéros). Le guichet comptait donc ses clients dans une variable de navigateur,
   * perdue au moindre rechargement ou changement de poste.
   * @returns {Promise} `{ success, data: { stats, counters } }`
   */
  getDailyPerformance: async () => {
    try {
      const response = await axios.get('/api/stats');
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des statistiques du jour:', error);
      throw error;
    }
  },

  getCounterStatus: async (counterId) => {
    try {
      const response = await axios.get(`${API_URL}/${counterId}`);
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération du statut du guichet:', error);
      throw error;
    }
  },

  /**
   * Mettre à jour le statut d'un guichet
   * @param {number} counterId - ID du guichet
   * @param {string} status - Nouveau statut (available, busy, closed)
   * @returns {Promise} Promesse résolue avec les données du guichet mis à jour
   */
  updateCounterStatus: async (counterId, status) => {
    try {
      const response = await axios.put(`${API_URL}/${counterId}`, { status });
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la mise à jour du statut du guichet:', error);
      throw error;
    }
  },

  /**
   * Récupérer les statistiques des guichets
   * @returns {Promise} Promesse résolue avec les statistiques des guichets
   */
  getCounterStats: async () => {
    try {
      const response = await axios.get(`${API_URL}/stats/daily`);
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des statistiques des guichets:', error);
      throw error;
    }
  },

  /**
   * Réinitialiser les compteurs journaliers
   * @returns {Promise} Promesse résolue avec un message de succès
   */
  resetCounters: async () => {
    try {
      const response = await axios.post(`${API_URL}/reset`);
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la réinitialisation des compteurs:', error);
      throw error;
    }
  }
};

export default counterService;
